import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// react component for creating beautiful carousel
import Carousel from "react-slick";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
// @material-ui/icons
// import Share from "@material-ui/icons/Share";
// import ShoppingCart from "@material-ui/icons/ShoppingCart";

import Apps from "@material-ui/icons/Apps"

// core components
import Header from "components/Header/Header.jsx";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// import Card from "components/Card/Card.jsx";
// import CardBody from "components/Card/CardBody.jsx";
// import CustomInput from "components/CustomInput/CustomInput.jsx";
// import SectionCarousel from "./SectionCarousel.jsx";

import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.jsx";

// import bg12 from "assets/img/bg12.jpg";
// import office2 from "assets/img/examples/office2.jpg";
// import dg1 from "assets/img/dg1.jpg";
// import dg2 from "assets/img/dg2.jpg";
// import dg3 from "assets/img/dg3.jpg";
import dg0 from "assets/img/image00.jpg";
import dg1 from "assets/img/image01.jpg";
import dg2 from "assets/img/image02.jpg";
// import dg3 from "assets/img/image03.jpg";
import dg4 from "assets/img/image04.jpg";
// import dg5 from "assets/img/image05.jpg";
// import dx_image from "assets/img/dx.jpg";
import ai_agent_image from "assets/img/ai_agents_image.jpg";

function SectionHeaders({ ...props }) {
  const { classes, ...rest } = props;
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false
  };

  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  };

  const smoothScroll = (e, target) => {
    // if (window.location.pathname === "/sections") {
      // var isMobile = navigator.userAgent.match(
      //   /(iPad)|(iPhone)|(iPod)|(android)|(webOS)|(Macintosh)|(Trident)|(Edge)/i
      // );
      var isEdge = navigator.userAgent.match(
        /(Trident)|(Edge)/i
      );
      var isChrome = navigator.userAgent.match(
        /(Chrome)/i
      );
      // var isMobile = true;
      if (isChrome && !isEdge) {
        // Chrome
        e.preventDefault();
        var targetScroll = document.getElementById(target);
        scrollGo(document.documentElement, targetScroll.offsetTop, 1250);
      } else {
        // Safari
        // Edge
        // IE11
      }
    // }
  };
  const scrollGo = (element, to, duration) => {
    var start = element.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 20;

    var animateScroll = function() {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  };

  return (
    // we've set the className to cd-section so we can make smooth scroll to it
    <div className="cd-section" {...rest}>
      {/* <div className={classes.sectionBlank} id="blanksection" /> */}
      {/* HEADER 3 START */}
      <div>
        <Header
          absolute
          brand="WEB BANANA UNITE"
          color="transparent"
          changeColorOnScroll={{
            height: 300,
            color: "primary"
          }}
          // state={true}
          links={
            <List className={classes.list + " " + classes.mlAuto}>
              <ListItem className={classes.listItem}>
                <Button
                  href="#home"
                  className={classes.navLink}
                  // onClick={e => e.preventDefault()}
                  // onClick={e => {}}
                  onClick={e => smoothScroll(e, "home")}
                  color="transparent"
                >
                  Home
                </Button>
              </ListItem>
              <ListItem className={classes.listItem}>
                <Button
                  href="#products"
                  className={classes.navLink}
                  // onClick={e => e.preventDefault()}
                  // onClick={e => {}}
                  onClick={e => smoothScroll(e, "products")}
                  color="transparent"
                >
                  Products
                </Button>
              </ListItem>
              <ListItem className={classes.listItem}>
                <Button
                  href="#workwith"
                  className={classes.navLink}
                  // onClick={e => e.preventDefault()}
                  // onClick={e => {}}
                  onClick={e => smoothScroll(e, "workwith")}
                  color="transparent"
                >
                  Work with
                </Button>
              </ListItem>
              <ListItem className={classes.listItem}>
                <Button
                  href="#pricing"
                  className={classes.navLink}
                  // onClick={e => e.preventDefault()}
                  // onClick={e => {}}
                  onClick={e => smoothScroll(e, "pricing")}
                  color="transparent"
                >
                  料金表
                </Button>
              </ListItem>
              <ListItem className={classes.listItem}>
                <Button
                  href="#aboutus"
                  className={classes.navLink}
                  // onClick={e => e.preventDefault()}
                  // onClick={e => {}}
                  onClick={e => smoothScroll(e, "aboutus")}
                  color="transparent"
                >
                  Who we are
                </Button>
              </ListItem>
              <ListItem className={classes.listItem}>
                <Button
                  href="#whatwewill"
                  className={classes.navLink}
                  // onClick={e => e.preventDefault()}
                  // onClick={e => {}}
                  onClick={e => smoothScroll(e, "whatwewill")}
                  color="transparent"
                >
                  What we will
                </Button>
              </ListItem>
              <ListItem className={classes.listItem}>
                <Button
                  href="#contacts"
                  className={classes.navLink}
                  // onClick={e => e.preventDefault()}
                  // onClick={e => {}}
                  onClick={e => smoothScroll(e, "contacts")}
                  color="transparent"
                >
                  お問合せ
                </Button>
              </ListItem>
            </List>
          }
        />
        <Carousel {...settings}>
          {/* Carousel -1 START */}
          <div>
            <div
              className={classes.pageHeader}
              style={{ backgroundImage: `url("${ai_agent_image}")` }}
            >
              <div className={classes.container}>
                <GridContainer>
                  <GridItem
                    xs={12}
                    sm={8}
                    md={8}
                    className={classNames(
                      classes.mlAuto,
                      classes.mrAuto,
                      classes.textCenter
                    )}
                  >
                    <div>
                      <h1 className={classes.title}>AIエージェント導入は無理でしょ？</h1>
                      <h4>
                        スキル・経験を持つ社員が退職してしまう前に、
                        熟練社員が持つ業務ノウハウをAIに学習させ企業資産化しましょう。
                      </h4>
                    <Button color="danger" size="lg" href="/ai_agent_on_smallbusiness.html" onClick={e => {}}>
                    <Apps/> スライドで詳しく
                    </Button>
                    </div>
                  </GridItem>
                </GridContainer>
              </div>
            </div>
          </div>
          {/* Carousel 0 END */}
          {/* Carousel 1 START */}
          <div>
            <div
              className={classes.pageHeader}
              style={{ backgroundImage: `url("${dg0}")` }}
            >
              <div className={classes.container}>
                <GridContainer>
                  {/* <GridItem
                    xs={12}
                    sm={7}
                    md={7}
                    className={classNames(classes.mlAuto, classes.textRight)}
                  > */}
                  <GridItem
                    xs={12}
                    sm={8}
                    md={8}
                    className={classNames(
                      classes.mlAuto,
                      classes.mrAuto,
                      classes.textCenter
                    )}
                  >
                    <div>
                      <h1 className={classes.title}>ブロックチェーン・ライブラリスイート</h1>
                      <h4>
                        Peer to Peer Network TCP NAT Traversal Library
                      </h4>
                      <h4>
                        Blockchain Library including Payout Monthly Basic income
                      </h4>
                      <h4>
                        Signaling Conductor for TCP NAT Traversal
                      </h4>
                      <Button color="white" simple size="lg" href="/blockChain/download.html" onClick={e => { }}>
                        <Apps /> 無料 download
                      </Button>
                    </div>
                  </GridItem>
                </GridContainer>
              </div>
            </div>
          </div>
          {/* Carousel 1 END */}
          {/* Carousel 2 START */}
          <div>
            <div
              className={classes.pageHeader}
              style={{ backgroundImage: `url("${dg1}")` }}
            >
              <div className={classes.container}>
                <GridContainer>
                  <GridItem xs={12} sm={6} md={6}>
                    <h1 className={classes.title}>暗号技術を活用したソフトウェアを開発</h1>
                    <h4>
                      著作物ライセンス管理
                    </h4>
                    <h4>
                      住民基本台帳ブロックチェーン
                    </h4>
                    <h4>
                      中央官庁・自治体文書管理ブロックチェーン
                    </h4>
                    <br />
                    <Button color="danger" size="lg" href="/smartContract.html" onClick={e => {}}>
                    <Apps/> Read more
                    </Button>
                    {/* <Button justIcon color="white" simple>
                      <i className="fab fa-twitter" />
                    </Button>
                    <Button justIcon color="white" simple>
                      <i className="fab fa-facebook-square" />
                    </Button>
                    <Button justIcon color="white" simple>
                      <i className="fab fa-get-pocket" />
                    </Button> */}
                  </GridItem>
                </GridContainer>
              </div>
            </div>
          </div>
          {/* Carousel -1 END */}
          {/* Carousel 0 START */}
          <div>
            <div
              className={classes.pageHeader}
              style={{ backgroundImage: `url("${dg2}")` }}
            >
              <div className={classes.container}>
                <GridContainer>
                  <GridItem
                    xs={12}
                    sm={8}
                    md={8}
                    className={classNames(
                      classes.mlAuto,
                      classes.mrAuto,
                      classes.textCenter
                    )}
                  >
                    <h1 className={classes.title}>AppStore40万ダウンロード</h1>
                    <h4>
                      システム手帳
                    </h4>
                    <br />
                    <Button color="danger" size="lg" href="/ipad/systemTecyou.html" onClick={e => {}}>
                    <Apps/> Read more
                    </Button>
                    {/* <div>
                      <Button color="white" simple size="lg" justIcon>
                        <i className="fab fa-twitter" />
                      </Button>
                      <Button color="white" simple size="lg" justIcon>
                        <i className="fab fa-facebook-square" />
                      </Button>
                      <Button color="white" simple size="lg" justIcon>
                        <i className="fab fa-google-plus-g" />
                      </Button>
                      <Button color="white" simple size="lg" justIcon>
                        <i className="fab fa-instagram" />
                      </Button>
                    </div> */}
                  </GridItem>
                </GridContainer>
              </div>
            </div>
          </div>
          {/* Carousel 2 END */}
          {/* Carousel 5 START */}
          <div>
            <div
              className={classes.pageHeader}
              style={{ backgroundImage: `url("${dg4}")` }}
            >
              <div className={classes.container}>
                <GridContainer>
                  {/* <GridItem
                    xs={12}
                    sm={7}
                    md={7}
                    className={classNames(classes.mlAuto, classes.textRight)}
                  > */}
                  <GridItem
                    xs={12}
                    sm={8}
                    md={8}
                    className={classNames(
                      classes.mlAuto,
                      classes.mrAuto,
                      classes.textCenter
                    )}
                  >
                    <div>
                    <Button color="white" simple size="lg" href="/campaign.html" onClick={e => {}}>
                    <Apps/> Read more
                    </Button>
                    </div>
                  </GridItem>
                </GridContainer>
              </div>
            </div>
          </div>
          {/* Carousel 5 END */}
        </Carousel>
      </div>
      {/* HEADER 3 END */}
    </div>
  );
}

export default withStyles(headersStyle)(SectionHeaders);



// WEBPACK FOOTER //
// ./src/views/SectionsPage/Sections/SectionHeaders.jsx